export default "__VITE_ASSET__6b502e4f__"